import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _liquidContent: {
      name: "Liquid Content",
      type: "liquidCodeEditor",
      description:
        "Specify the the Shopify Liquid source code to embed in this component.",
      defaultValue: null,
    },
  };
}

const styleElements = {
  root: {},
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: false,
    customProps: convertToLegacyProps(getConfigurableProps()),
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
    ancestorDisallowList: [
      {
        elementTypes: ["shopifyArticle"],
        message: "Shopify Liquid can't be used in Shopify Articles",
      },
      {
        ancestorTypes: ["button"],
        message: "Shopify Liquid cannot be nested inside buttons.",
      },
    ],
  },
} satisfies ComponentConfig;

export default config;
